import { put, call, take, takeLatest, takeEvery } from "redux-saga/effects";

import {
  GET_PROFILE_DATA_SAGA,
  SET_PROFILE_DATA,
  EDIT_PROFLIE_DATA_SAGA,
  END_LOADING,
} from "../actionTypes";

import { apiCaller } from "../../custom-hooks/useApi";
import { profile_apiCalls } from "../../services/agent";

export function* getProfileDataSaga(action) {
  const { data, status } = yield apiCaller({
    api: profile_apiCalls.apiCall_getProfile,
    toastMessage: true,
    onErrorMessage: "دریافت اطلاعات پروفایل با خطا مواجه شد .",
  });

  yield put({ type: END_LOADING });
  if (status === 200) yield put({ type: SET_PROFILE_DATA, payload: data.data });
}

export function* editProfileSaga(action) {
  const { data, status } = yield apiCaller({
    api: profile_apiCalls.apiCall_editProfile,
    apiArguments: action.payload,
    toastMessage: true,
    onSuccessMessage: "ویرایش پروفایل با موفقیت انجام شد .",
    onErrorMessage: "ویرایش پروفایل با خطا مواجه شد .",
  });

  yield put({ type: END_LOADING });
  if (status === 200) yield put({ type: GET_PROFILE_DATA_SAGA });
}

export function* watchGetProfileData() {
  yield takeEvery(GET_PROFILE_DATA_SAGA, getProfileDataSaga);
}

export function* watchEditProfileData() {
  yield takeLatest(EDIT_PROFLIE_DATA_SAGA, editProfileSaga);
}
